export const getDisabledPagesProps = (data) => {
    if(!data) return {}
    const hideNumOpenSlots = data.disable_pages_app.some(item => item.area === 'schedule' && item.section_name === 'slotsOpen');
    const hideNumRegisteredUsers = data.disable_pages_app.some(item => item.area === 'schedule' && item.section_name === 'arrivingAmount');
    const hideCoachDisplay = data.disable_pages_app.some(item => item.area === 'schedule' && item.section_name === 'coach');
    const hideWhoIsBooked = data.disable_pages_app.some(item => item.area === 'schedule' && item.section_name === 'whoIsBooked');
    const showStandBy = data.disable_pages_app.some(item => item.area === 'schedule' && item.section_name === 'standBy');
    const hideSpaceName = data.disable_pages_app.some(item => item.area === 'schedule' && item.section_name === 'space');
    const slots = data.max_users - data.registered;

    return {
        showCoach: !hideCoachDisplay,
        showWaitList: showStandBy,
        showBookedUsers: !hideWhoIsBooked,
        showNumOpenSpots: !hideNumOpenSlots,
        showNumRegistered: !hideNumRegisteredUsers,
        showSpaceName: !hideSpaceName,
        openSpots: slots,
        registered: data.registered,
        maxUsers: data.max_users,
        inWaitList: data.stand_by,
        positionInWaitList: data.stand_by_position
    };
}

export const getDisabledPagesCourseProps = (data) => {
    const hideNumOpenSlots = data.disable_pages_app.some(item => item.area === 'course' && item.section_name === 'spots');
    const hideNumRegisteredUsers = data.disable_pages_app.some(item => item.area === 'course' && item.section_name === 'participantNumber');
    const hideStaffMembersDisplay = data.disable_pages_app.some(item => item.area === 'course' && item.section_name === 'staffMembers');
    const hideNumRemainingSlots = data.disable_pages_app.some(item => item.area === 'course' && item.section_name === 'remainingSlots');

    return {
        showCoach: !hideStaffMembersDisplay,
        showNumOpenSpots: hideNumOpenSlots,
        showNumRegistered: hideNumRegisteredUsers,
        showNumRemainingSlots: hideNumRemainingSlots
    };
}